<template>
  <div class="sku-dropdown">
    <div class="dropdown-toggle" type="button" data-toggle="dropdown">
      {{dropdownName}}
      <span v-if="dropdownType === 'select'">
        :
        <span class="selected-value ml-1 mr-1">{{selected}}</span>
      </span>
      <i class="fa fa-angle-down" aria-hidden="true"></i>
    </div>
    <ul class="dropdown-menu">
      <li
        v-for="item in menuItems" v-show="checkDisplayParentMenu(item) && (item.show === true || (typeof item.show === 'undefined'))"
        v-bind:class="{'dropdown-submenu': item.children, 'pull-left': item.children && item.pullLeft}"
        v-bind:key="item.name"
      >
        <a
          v-bind:class="{'have-child': item.children}"
          :href="item.href"
          @click="selectMenu($event, item.name)"
        >
          {{item.name}}
          <i class="fa fa-angle-down ml-2" aria-hidden="true" v-if="item.children"></i>
        </a>
        <hr v-if="item.divide" />
        <ul class="dropdown-menu" v-if="item.children">
          <li
            v-for="child in item.children"
            v-bind:class="{'dropdown-submenu': child.children}"
            v-bind:key="child.name" v-show="child.show === true || (typeof child.show === 'undefined')"
          >
            <a
              v-bind:class="{'have-child': child.children}"
              :href="child.href"
              @click="selectMenu($event, child.name)"
            >
              {{child.name}}
              <i
                class="fa fa-angle-down ml-2"
                aria-hidden="true"
                v-if="child.children"
              ></i>
            </a>
            <ul class="dropdown-menu" v-if="child.children">
              <li v-for="child in child.children" v-bind:key="child.name">
                <a tabindex="-1" :href="child.href">{{child.name}}</a>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import "jquery/src/jquery.js";
import {checkDisplayParentMenu} from '../../common/helper';

export default {
  name: "Dropdown",
  props: {
    menuItems: {
      type: Array,
      required: true
    },
    dropdownName: {
      type: String,
      required: true
    },
    dropdownType: {
      type: String,
      required: false
    }
  },
  data: function() {
    return {
      selected: this.menuItems[0].name
    };
  },
  methods: {
    selectMenu: function(event, value) {
      this.selected = value;
      if (event.target.className === "have-child") {
        event.stopPropagation();
        event.preventDefault();
      }
    },
    checkDisplayParentMenu: checkDisplayParentMenu
  }
};
</script>

<style scoped>
.dropdown-submenu {
  position: relative;
}

.dropdown-submenu .dropdown-menu {
  top: 0;
  left: 100%;
  margin-top: -1px;
}

.sku-dropdown {
  position: relative;
}
.sku-dropdown hr {
  border-top: 1px solid #eee;
  margin: 5px 30px;
}
.sku-dropdown .dropdown-menu {
  padding-top: 8px;
  padding-bottom: 8px;
  box-shadow: none;
  border: 1px solid #e7eaec;
  border-radius: 8px;
  left: auto;
  top: 30px;
}

.sku-dropdown .dropdown-menu > li a {
  font-size: 12px;
  color: #676a6c;
  white-space: nowrap;
  padding: 7px 30px;
  display: block;
  cursor: pointer;
}

.sku-dropdown .dropdown-menu > li a:hover {
  text-decoration: none;
  background: #ecf0f1 !important;
}

.sku-dropdown .dropdown-menu .dropdown-item {
  padding: 0;
}
.sku-dropdown .dropdown-submenu > .dropdown-item {
  padding: 7px 30px;
  font-size: 12px;
  color: #676a6c;
  display: block;
}

.sku-dropdown .dropdown-menu .dropdown-item a {
  padding: 7px 30px;
  font-size: 12px;
  color: #676a6c;
  display: block;
}

.sku-dropdown .dropdown-menu .dropdown-item:hover a {
  background: #ecf0f1 !important;
  color: #1e242f;
  text-decoration: none;
}

.sku-dropdown .dropdown-menu .dropdown-divider {
  margin: 5px 30px;
  border-top: 1px solid #eee;
}

.sku-header .dropdown-submenu {
  position: relative;
}

.sku-header .dropdown-submenu > .dropdown-menu {
  top: 0;
  left: 100%;
  margin-top: -6px;
  margin-left: -1px;
  border-radius: 8px;
}

.sku-header .dropdown-submenu:hover > .dropdown-menu {
  display: block;
}

.dropdown-item.active,
.dropdown-item:active {
  background-color: transparent;
}

.sku-header .dropdown-submenu:hover > a:after {
  border-left-color: #fff;
}

.sku-header .dropdown-submenu.pull-left {
  float: none;
}

.sku-header .dropdown-submenu.pull-left > .dropdown-menu {
  left: -100%;
  margin-left: 10px;
  -webkit-border-radius: 6px 0 6px 6px;
  -moz-border-radius: 6px 0 6px 6px;
  border-radius: 6px 0 6px 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Dropdown.vue